module.exports = __webpack_public_path__ + "static/media/DSCF9019.ad6898ac.JPG";